module.exports = __webpack_public_path__ + "img/excel.c3089518.svg";